/**
 * 혼합가스 성분 물성 데이터 로더.
 *
 * 원본 데이터: /data/gas-components.json
 *   - 분자량은 원자량에서 화학식으로 정확히 계산(검증: `python
 *     data/verify-gas-components.py`)
 *   - 이상기체 정압비열·점도는 Perry's Chemical Engineers' Handbook /
 *     NIST WebBook 인용값(공학적 근사 — 25 ℃ 기준, 온도가 크게 다르면
 *     오차가 는다)
 *
 * 이 파일은 JSON 에 타입만 입힌다.
 */
import raw from "../../data/gas-components.json";

export interface GasComponent {
  readonly key: string;
  readonly label: string;
  readonly formula: string;
  readonly molecularWeight: number;
  /** 25 ℃ 이상기체 정압비열 (J/(kmol·K)) */
  readonly idealGasCpJKmolK: number;
  /** 20~25 ℃, 1 atm 순물질 절대점도 (cP) */
  readonly viscosityCp: number;
  /** 공기 중 폭발하한계 (vol%). 불연성 성분은 null(gas-components.json combustionComment 참고). */
  readonly lelVolPercent: number | null;
  /** 공기 중 폭발상한계 (vol%). 불연성 성분은 null. */
  readonly uelVolPercent: number | null;
  /** 연소열량, HHV (MJ/kg). 불연성 성분은 null. */
  readonly hhvMjKg: number | null;
  /** 질소등가계수 Kᵢ(KOSHA P-179-2022/ISO 10156, nitrogenEquivalentComment 참고).
   * 불연성 성분에만 있다(가연성 성분은 undefined) — 그중에서도 표에 없는
   * 성분(염소 등)은 null(추측해서 채우지 않음, 이 보정 계산 자체를 못 함). */
  readonly nitrogenEquivalent?: number | null;
}

export const GAS_COMPONENTS: readonly GasComponent[] = raw.components;

const BY_KEY = new Map(GAS_COMPONENTS.map((c) => [c.key, c]));

export function findGasComponent(key: string): GasComponent | null {
  return BY_KEY.get(key) ?? null;
}
